---
title: "General Meeting - [DATE]"
date: "[YYYY-MM-DD]"
startTime: "[HH:MM]"
endTime: "[HH:MM]"
timezone: "America/Los_Angeles"
type: "General Meeting"
status: "Draft"
attendees: [NUMBER]
summary: "[BRIEF_SUMMARY]"
published: false
---

<script lang="ts">
	export const metadata = {
		title: "General Meeting - [DATE]",
		date: "[YYYY-MM-DD]",
		startTime: "[HH:MM]",
		endTime: "[HH:MM]",
		timezone: "America/Los_Angeles",
		type: "General Meeting",
		status: "Draft",
		attendees: "[NUMBER]",
		summary: "[BRIEF_SUMMARY]",
		published: false
	};
</script>

# General Meeting Minutes
## [FULL_DATE]

**Meeting Type:** General Membership Meeting  
**Date:** [FULL_DATE]  
**Time:** [START_TIME] - [END_TIME] MST  
**Location:** [MEETING_LOCATION]  
**Meeting Called to Order:** [START_TIME] by [PRESIDENT_NAME]  

### Attendance
**Members Present:** [NUMBER]  
**Officers Present:** [LIST_OFFICERS]  
**Guests:** [NUMBER_GUESTS]  

### Opening
- Pledge of Allegiance
- Moment of silence for Silent Keys
- Introduction of guests and new members

### Officer Reports

#### President's Report
[PRESIDENT_REPORT_CONTENT]

#### Vice President's Report
[VP_REPORT_CONTENT]

#### Secretary's Report
- Motion to approve [PREVIOUS_MONTH] meeting minutes
- [MOTION_RESULT]

#### Treasurer's Report
- Current balance: $[AMOUNT]
- [INCOME_EXPENSE_SUMMARY]
- Motion to approve treasurer's report [MOTION_RESULT]

### Committee Reports

#### Repeater Committee
[REPEATER_COMMITTEE_REPORT]

#### Emergency Communications (AUXCOMM)
[AUXCOMM_REPORT]

#### Events Committee
[EVENTS_COMMITTEE_REPORT]

### Old Business
1. **[ITEM_1_TITLE]**
   - [STATUS_UPDATE]
   - [ACTION_ITEMS_REVIEW]

2. **[ITEM_2_TITLE]**
   - [DETAILS_AND_OUTCOMES]

### New Business
1. **[NEW_ITEM_1_TITLE]**
   - [DISCUSSION_DETAILS]
   - [MOTION_AND_RESULT]

2. **[NEW_ITEM_2_TITLE]**
   - [DISCUSSION_DETAILS]
   - [MOTION_AND_RESULT]

### Announcements
- Next meeting: [NEXT_MEETING_DATE] at [TIME]
- Weekly net: Every Tuesday at 1830 on [REPEATER_INFO]
- [OTHER_ANNOUNCEMENTS]

### Technical Presentation
**Topic:** [PRESENTATION_TITLE]  
**Presenter:** [NAME_AND_CALL_SIGN]  
**Summary:** [BRIEF_DESCRIPTION]

### Adjournment
Meeting adjourned at [END_TIME].

### Action Items
- [ ] [SECRETARY] Distribute approved minutes to members
- [ ] [ASSIGNEE] [SPECIFIC_ACTION_ITEM]
- [ ] [ASSIGNEE] [SPECIFIC_ACTION_ITEM]

---

*Minutes prepared by: [SECRETARY_NAME_AND_CALL_SIGN]*  
*Minutes approved: [APPROVAL_DATE]*